import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { BatchShipmentsOrder } from "@app/shared/CSDAModels/BatchShipmentsOrder";
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { StorageService } from "@app/core/services/storage.service";
import { Router } from "@angular/router";

@Component({
  selector: 'app-batch-shipments-report',
  standalone: true,
  imports: [CommonModule, TranslateModule, MatDialogModule, MatIconModule],
  templateUrl: './batch-shipments-report.component.html',
  styleUrls: ['./batch-shipments-report.component.scss']
})

export class BatchShipmentsReportComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { shipments: BatchShipmentsOrder[] },
    private dialogRef: MatDialogRef<BatchShipmentsReportComponent>,
    private translate: TranslateService,
    private storageService: StorageService,
    private router: Router
) {}
  
  
  get shipments() {
    return this.data.shipments || [];
  }
  
  close(): void {
    this.dialogRef.close();
  }

  showIssue(shipment: any) {
    Swal.fire({
      title: shipment.IssueType,
      text: shipment.Issue,
      icon: 'warning',
      confirmButtonText: 'OK',
      confirmButtonColor: '#3085d6'
    });
  }
  
  GoToOrder(OrderNumber: number) {
    this.storageService.setShipmentOrigin('/')
		this.storageService.setGoToStepTwo("false");
    sessionStorage.setItem("quoteType", '8');
    this.storageService.setOrderId(OrderNumber.toString());
		this.router.navigate(['/orders', 'CreateShipment']);
    this.close();
  }
}
